package io.github.jpuf.portfolio.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.color.ColorVar
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.github.jpuf.portfolio.toSitePalette
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Span

val FooterStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .backgroundColor(colorMode.toSitePalette().nearBackground)
        .padding(1.2.cssRem)
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Row(
        modifier = FooterStyle.toModifier().displayIfAtLeast(Breakpoint.MD).then(modifier),
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        KobwebAttribution()
        FontAttribution()
    }
    Column(modifier = FooterStyle.toModifier().displayUntil(Breakpoint.MD).then(modifier)) {
        KobwebAttribution()
        FontAttribution()
    }
}

@Composable
private fun KobwebAttribution() {
    Span(Modifier.fontFamily("VG5000").textAlign(TextAlign.Start).toAttrs()) {
        SpanText("Written in Kotlin with ")
        Link(
            "https://github.com/varabyte/kobweb",
            "Kobweb",
            Modifier.fontFamily("VG5000").setVariable(ColorVar, ColorMode.current.toSitePalette().brand.accent),
            variant = UncoloredLinkVariant
        )
        SpanText(". © James Bennett 2025")
    }
}

@Composable
private fun FontAttribution() {
    Span(Modifier.fontFamily("VG5000").textAlign(TextAlign.End).toAttrs()) {
        SpanText("Font: Justin Bihan's VG5000 via ")
        Link(
            "https://velvetyne.fr/",
            "velvetyne.fr",
            Modifier.setVariable(ColorVar, ColorMode.current.toSitePalette().brand.accent),
            variant = UncoloredLinkVariant
        )
    }
}